import '../styles/roadmap.css';

import React from 'react';

const RoadmapCard = () => {
  return (
    <div className="roadmapWrapper">
      <h1 className="roadmapTitle">Milestone Development</h1>
      <div className="container">
        <div className="roadmap">
          <div className="road-map"></div>
        </div>
        <section className="timeline-wrapper">
          <div className="middle-line"></div>

          <div className="box box-top">
            <div className="date"></div>
            <div className="box-content">
              <p className="boxPara">
                Completed JavaScript Master at Clever Programmer.
              </p>
              <p id="date1">Jan 3 2021</p>
            </div>
          </div>

          <div className="box box-bottom">
            <div className="date"></div>
            <div className="box-content">
              <p id="date1">Jan 15 2020</p>
              <p className="boxPara">Developed NextJS and MegaMenu websites.</p>
            </div>
          </div>

          <div className="box box-top">
            <div className="date"></div>
            <div className="box-content">
              <p className="boxPara">
                Discovered React JavaScript MERN programming.
              </p>
              <p id="date1">Apr 10 2019</p>
            </div>
          </div>

          <div className="box box-bottom">
            <div className="date"></div>
            <div className="box-content">
              <p id="date1">Mar 24 2018</p>
              <p className="boxPara">
                Learned Xamarin iOS / Andriod App development.
              </p>
            </div>
          </div>

          <div className="box box-top">
            <div className="date"></div>
            <div className="box-content">
              <p className="boxPara">Developed Apple Swift iPhone/iPad Apps.</p>
              <p id="date1">Mar 3 2017</p>
            </div>
          </div>

          <div className="box box-bottom">
            <div className="date"></div>
            <div className="box-content">
              <p className="boxPara">
                {' '}
                Begun developing php/Mysql FTP websites
              </p>
              <p id="date1">Feb 20 2016</p>
            </div>
          </div>

          <div className="box box-top">
            <div className="date"></div>
            <div className="box-content">
              <p className="boxPara">
                {' '}
                Developed HTML and Wix webpage frameworks
              </p>
              <p id="date1">Jan 30 2013</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RoadmapCard;
